import React, { useState, useContext } from 'react';
import { ThemeProvider } from 'styled-components';

import GobalStyle from '../src/styles/global';
import { Router } from 'react-router-dom';
import { AuthProvider } from './Context/AuthContext';
import { Context } from './Context/ThemeContext';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Routes from './routes';
import history from './history';

import 'fontsource-roboto';

const App = () => {

	const {theme} = useContext(Context);
	return (
		<div className="App">
			<ThemeProvider theme={theme}>
				<GobalStyle />
				<ToastContainer />
				<AuthProvider>
					<Router history={history}>
						<Routes />
					</Router>
				</AuthProvider>
			</ThemeProvider>
		</div>
	);
}

export default App;
